<template>
    <v-layout>
        <v-app>

            <v-main v-if="ready">

                <router-view  />

            </v-main>
        </v-app>
    </v-layout>
</template>
<script>
import { getToken, clearToken } from "@/services/auth";
import api from "@/services/api";
import { useMainStore } from "@/store";
import { mapState } from "pinia";
import Config from "@/config";
import axios from "axios";

export default {
    // eslint-disable-next-line vue/no-unused-components
    data() {
        return {
            ready: false,
            isMenuOpen: false,
            loading: false,
            message: '',
            isPublicPath: false,
            isSubscriptionPath: false,
            publicPaths: [
                "/login", "/signup", "/register","/register/process",
                "/redirect", "/welcome", "/forget-password","/password-reset"
            ].map(path => path.replace(/\/$/, ''))
        };
    },
    computed: {
        ...mapState(useMainStore, ["user"]),
        daysUntilExpiration() {
            const expiry = new Date(this.user.subscription.end_date);
            const today = new Date();
            const diffTime = expiry - today;
            return Math.ceil(diffTime / (1000 * 60 * 60 * 24));
        },
    },
    watch: {
        '$route'(to) {
            this.checkIsPublicPath(to.path);
            this.checkIsSubscriptionPath(to.path);
        }
    },
    created() {
        // Check if the auth token exists
        const token = getToken();
        if (token) {
            // If token exists, set it in Axios headers for future requests
            axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
            // Initialize flags for current route
            this.checkIsSubscriptionPath(this.$route.path);
            this.checkIsPublicPath(this.$route.path);
            setTimeout(() =>{
                if (this.publicPaths.includes(this.$route.path)) {
                    this.$router.replace('/');
                }
            },500)

        }
    },
    methods: {
        async downloadTaxStatementPdf() {
            this.loading = true;
            try {
                // Make a GET request to the API endpoint, expecting a binary PDF response
                const response = await api.get(`/reports/download-tax-statement`, {
                    responseType: 'blob', // Tell Axios to treat the response as binary data
                });

                // Create a Blob from the binary response data
                const blob = new Blob([response.data], { type: 'application/pdf' });

                // Generate a temporary URL for the Blob
                const url = window.URL.createObjectURL(blob);

                // Create a hidden <a> element to trigger the download
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'tax_statement.pdf'); // Set the filename
                document.body.appendChild(link);
                link.click(); // Trigger the download
                document.body.removeChild(link); // Clean up the DOM

                // Free up memory by revoking the temporary URL
                window.URL.revokeObjectURL(url);

                this.loading = false;
            } catch (err) {
                console.log(err);
                this.loading = false;
                this.error = 'Operation failed';
            }
        },
        checkIsPublicPath(path) {
            const normalizedPath = path.replace(/\/$/, '');

            // Check static paths
            const isStaticPublic = this.publicPaths.includes(normalizedPath);

            // Check dynamic password reset path
            const isPasswordReset = /^\/password-reset\/[a-zA-Z0-9]+/.test(normalizedPath);

            this.isPublicPath = isStaticPublic || isPasswordReset;
        },

        checkIsSubscriptionPath(path) {
            const normalizedPath = path.replace(/\/$/, '');
            // Allowlist subscription-related pages even when user has no subscription
            this.isSubscriptionPath = normalizedPath.startsWith('/subscription/');
        },

        checkAuth() {
            const token = getToken();
            this.checkIsPublicPath(this.$route.path);
            this.checkIsSubscriptionPath(this.$route.path);
            setTimeout(() =>{
                if (!token) {
                    if (!this.publicPaths.includes(this.$route.path) && !this.$route.path.startsWith('/password-reset')) {
                        this.$router.replace({
                            path: "/",
                            query: { redirect: this.$route.fullPath }
                        }).catch(() => {});
                    }
                    this.ready = true;
                    return;
                }
                if (token) {
                    if (this.publicPaths.includes(this.$route.path)) {
                        this.$router.replace({
                            path: "/",
                            query: { redirect: this.$route.fullPath }
                        }).catch(() => {});
                    }
                    this.ready = true;
                    return;
                }
                try {
                    const res = api.post(`/checkToken/${token}`);
                    if (res.data.success) {
                        api.defaults.headers.common["Authorization"] = `Bearer ${token}`;
                        useMainStore().$patch({ user: res.data.user });
                        this.handlePostAuthRedirect();
                    } else {
                        this.logoutUser();
                    }
                } catch (err) {
                    console.error("Auth error:", err);
                    this.logoutUser();
                } finally {
                    this.ready = true;
                }
            },500)

        },

        async handlePostAuthRedirect() {
            // Handle subscription status
            if (this.user.subscription_status === 'none' && !this.isPublicPath && !this.isSubscriptionPath) {
                await this.$router.replace("/subscription/select");
                return;
            }

            // Handle original redirect
            if (this.$route.query.redirect) {
                const redirectPath = this.$route.query.redirect;
                delete this.$route.query.redirect;
                await this.$router.replace(redirectPath).catch(() => {});
            }
        },

        sendMessage() {
            if (!this.message.trim()) {
                alert(this.$t('message_required'));
                return;
            }

            const context = `\n\n[${this.user?.id || 'guest'}@${this.$route.path}]`;
            const url = `https://wa.me/${Config.contactnumber}?text=${
                encodeURIComponent(this.message + context)
            }`;
            window.open(url, "_blank");
            this.isMenuOpen = false;
            this.message = '';
        },

        logoutUser() {
            clearToken();
            useMainStore().$reset();
            this.$router.replace({
                path: "/login",
                query: { redirect: this.$route.fullPath }
            });
        }
    },
    beforeMount() {
        this.checkAuth();
    }
};
</script>
<style>
#app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}
</style>
